import * as React from 'react';
// mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
// redux
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store/store';
import { createProject } from '../../store/slices/projectsSlice';
// types
import Project from '../../interfaces/Project.interface';
// axios
import api from '../../axios';

interface AddProjectDialogProps {
  onClose: () => void;
  onSave: (id: number) => void;
}

export default function AddProjectDialog(props: AddProjectDialogProps) {
  // props
  const onCloseCallback = props.onClose;
  const onSaveCallback = props.onSave;
  
  // hooks
  const dispatch = useDispatch<AppDispatch>();
  
  // state
  const [ showAddProjectDialog, setShowAddProjectDialog ] = React.useState<boolean>(true);
  const [ addProjectName, setAddProjectName ] = React.useState<string>('');
  const [ addLoading, setAddLoading ] = React.useState<boolean>(false);

  const handleAddProject = () => {
    setAddLoading(true);
    api.post(`/projects/create`, {
      name: addProjectName
    })
      .then((res) => {
        const createdProject: Project = res.data;
        dispatch(createProject(createdProject));
        onSaveCallback(createdProject.id);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setAddLoading(false);
        setShowAddProjectDialog(false);
        setAddProjectName('');
      })
  }

  return (
    <Dialog
      open={showAddProjectDialog}
      onClose={() => { setShowAddProjectDialog(false); setAddProjectName(''); onCloseCallback(); }}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
          },
        },
      }}
    >
      <DialogTitle>
        Add Project
      </DialogTitle>
      <DialogContent>
        <TextField
          sx={{ minWidth: 300 }}
          label="Project Name"
          value={addProjectName}
          onChange={(e) => { setAddProjectName(e.target.value); }}
          autoFocus
          required
          id="name"
          variant="standard"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={() => { setShowAddProjectDialog(false); setAddProjectName(''); onCloseCallback(); }}>Cancel</Button>
        <Button
          type='submit'
          variant='contained'
          loading={addLoading}
          onClick={() => { handleAddProject(); }}
          disabled={addProjectName.length < 1}
        >Add</Button>
      </DialogActions>
    </Dialog>
  )
}